(() => {
  const run = () => {
    try {
      document.querySelectorAll('img').forEach((img) => {
        const src = img.getAttribute('src') || '';
        const alt = (img.getAttribute('alt') || '').toLowerCase();
        if ((src.includes('800x800') || src.includes('width=90') || ['paypal','visa','mastercard','american express','shop pay'].some(v => alt.includes(v))) && !img.hasAttribute('width')) {
          img.setAttribute('width', '90');
        }
        if ((src.includes('800x800') || src.includes('width=90') || ['paypal','visa','mastercard','american express','shop pay'].some(v => alt.includes(v))) && !img.hasAttribute('height')) {
          img.setAttribute('height', '90');
        }
        if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      });
    } catch(e) {}
  };
  if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2500 });
  else window.addEventListener('load', () => setTimeout(run, 800), { once: true });
})();
